import React = require('react');
import AdmIcons from '../../../../../../../components/Icons/AdmIcons';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../redux/IStore';
import { actions as authActions, IAuthActions } from '../../../../../../../services/auth/reducer';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';

interface IRepurchase {
  id: string;
  coverLevel: string;
  actions: {
    auth: IAuthActions;
  };
}

const RepurchaseQuote = ({ id, coverLevel, actions }: IRepurchase) => {

  const handleRepurchase = () => {
    actions.auth.retrieveExpiredQuote(id)
  }

  return (
    <div className={'repurchase-container'} onClick={handleRepurchase}>
      <div>
        <div><b>Renew this quote</b></div>
        <div>Start a quote with these details</div>
        <div style={{ paddingTop: '10px' }}>
          <AdmIcons name={'ShieldTicked'} color={coverLevel}/>
        </div>
      </div>
    </div>
  )
}

export default flow([
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        auth: bindActionCreators({ ...authActions }, dispatch),
        push: bindActionCreators(push, dispatch),
      }
    }),
  ),
])(RepurchaseQuote);
